import * as module from './index.js';
export default module;
